<span>
  <aurora-button (click)="fileInput.click()" [disabled]="this.model.inProgress || this.model.importComplete" variant="ghost">
    <aurora-icon icon="folder-open" *ngIf="!this.model.inProgress && !this.model.importComplete" documentDropZone (filesDroppedEmitter)="onFilesDropped($event)" [class.disabled]="this.model.inProgress || this.model.importComplete" ngbTooltip="Drag and Drop Files here, or Click to Select Files."></aurora-icon>
    <aurora-icon icon="checkmark" *ngIf="model.importComplete && model.failedCount == 0"></aurora-icon>
    <aurora-icon icon="trash" style="color: red" *ngIf="model.importComplete && model.failedCount > 0"></aurora-icon>
    <span *ngIf="model.inProgress">
      <i class="fa fa-ep-in-progress fa-spin"></i>
      <span *ngIf="this.model.totalImportCount > 1" class="fa-stack-1x" style="font-weight: 600; font-size: 1rem">{{
        this.model.totalImportCount - this.model.importNumber
      }}</span>
    </span>
  </aurora-button>
</span>

<input
  #fileInput
  type="file"
  multiple="true"
  style="display: none"
  id="fileSelect"
  name="fileSelect"
  accept=".doc,.docx,.jpg,.jpeg,.pdf,.xls,.xlsm,.xlsx,.msg,.wav,.mp4,.txt,.bmp"
  (change)="filesSelected($event)"
/>
